import { RequiredFieldTooltip } from '@/shared/components/required-field-tooltip';
import { Field } from '@noorden-insurtech/alba-design-system';
import type { TFieldContext } from '../types';

export type DateFieldProps = {
  label: string;
  placeholder?: string;
  required?: boolean;
  minDate?: string;
  maxDate?: string;
  disabled?: boolean;
};

export function createDateField(useFieldContext: () => unknown) {
  return function DateField({
    label,
    placeholder,
    required,
    minDate,
    maxDate,
    disabled,
  }: DateFieldProps) {
    const field = useFieldContext() as TFieldContext<string>;

    const showError =
      field.state.meta.isTouched && field.state.meta.errors.length > 0;

    return (
      <RequiredFieldTooltip active={required}>
        <Field.Root invalid={!!field.state.meta.errors.length}>
          <Field.Label>
            {label}
            {required && <span className='text-alba-error-red-500'>*</span>}
          </Field.Label>
          <Field.Input
            type='date'
            value={field.state.value || ''}
            onChange={e => field.handleChange(e.target.value)}
            onBlur={field.handleBlur}
            placeholder={placeholder}
            min={minDate}
            max={maxDate}
            disabled={disabled}
          />
          {showError && (
            <Field.ErrorText>{field.state.meta.errors[0]}</Field.ErrorText>
          )}
        </Field.Root>
      </RequiredFieldTooltip>
    );
  };
}
